module.exports = __webpack_public_path__ + "img/anzhuanglv.9a57e490.png";